var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-result',{attrs:{"icon":"success","title":"成功提示","subTitle":"关注电子送货单电子货单公证号可收到订阅信息"}},[_c('template',{slot:"extra"},[_c('img',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"src":require("@/assets/public.png"),"alt":""}})])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }